import React from "react";
import { Row, Col } from "react-bootstrap";
import "./component2.css";

const Component2 = ({ title, paragraphs = [], tips = [], list = false }) => {
  return (
    <div className="section_block">
      <Row>
        <Col xs={12}>
          <h3 className="sub_title">{title}</h3>
          {paragraphs.map((para, index) => (
            <p key={index} className="passage">
              {para}
            </p>
          ))}

          <div className="tips_list">
            <p  className="passage">
            {list ? (
              <ul>
                {tips.map((tip, index) => (
                  <li key={index}>{tip}</li>
                ))}
              </ul>
            ) : (
              tips.map((tip, index) => (
                <p key={index} className="passage">
                  {tip}
                </p>
              ))
            )}
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Component2;
